import React from 'react';

/**
 * ProgressRing — circular progress dial with a centered percentage/label.
 * Used for collection-rate ("tasa de cobro").
 */
export function ProgressRing({ value = 0, max = 100, size = 120, stroke = 12, tone = 'green', label, style = {}, ...rest }) {
  const pct = Math.max(0, Math.min(1, value / max));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const colors = { green: 'var(--brand-green)', amber: 'var(--status-pending)', red: 'var(--status-overdue)', blue: 'var(--accent-blue)' };
  return (
    <div style={{ position: 'relative', width: size, height: size, fontFamily: 'var(--font-sans)', ...style }} {...rest}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--surface-2)" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={colors[tone] || colors.green} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)} style={{ transition: 'stroke-dashoffset .4s ease' }} />
      </svg>
      <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontSize: size * 0.24, fontWeight: 800, color: 'var(--text-strong)', letterSpacing: '-.01em' }}>
          {Math.round(pct * 100)}%
        </span>
        {label && <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-hint)' }}>{label}</span>}
      </div>
    </div>
  );
}
